module.exports = __webpack_public_path__ + "img/header-background.27e6e2a6.png";